// src/components/GeneralFeatures.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import styles from './GeneralFeatures.module.scss';
import features from '../../data/generalFeaturesData.json';

// require.context para cargar todas las .webp de la carpeta
const images = require.context(
  '../../assets/images/GeneralFeatures',
  false,
  /\.webp$/
);

// Variants para el fade-up
const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

const GeneralFeatures = () => (
  <section className={styles.container}>
    {features.map((item, idx) => {
      const src = images(`./${item.icon}`);
      return (
        <Link
          key={item.link}
          to={`/productos/${item.link}`}
          className={styles.linkWrapper}
        >
          <motion.div
            className={styles.card}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5, delay: idx * 0.1 }}
            whileHover={{
              scale: 1.1,
              transition: { type: 'spring', stiffness: 300, damping: 10 }
            }}
          >
            <img
              src={src}
              alt={item.description}
              className={styles.icon}
            />
            <p className={styles.description}>{item.description}</p>
          </motion.div>
        </Link>
      );
    })}
  </section>
);

export default GeneralFeatures;
